/**
 * Clave de licencia community de PrimeNG.
 * Es global (no varía por entorno), por lo que se centraliza aquí como
 * única fuente de verdad en lugar de duplicarla en los environments.
 */
export const PRIMENG_LICENSE_KEY =
  'eyJpZCI6IjQzNGIwOWJjLWNiODAtNDk0OC1hODc4LTcyZDM5ZmVjMzAwYiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODQwNDE0NDMsImV4cCI6MTgxNTU3NzQ0M30.G1w0__W5tD3_aC9FmtRK-xP6MuxmKxFdpAvUN-4lG5-mM1EL9-7jLvliLsIhrTxQ5ztzxPxqaxDOAhCqmkuVBw';
